import { Fragment } from 'react';
import { Field, FormSection } from 'redux-form';

import InputField from 'dashboard/components/FormControls/InputField';

interface InputMaxRetriesProps {
  name: string;
  editable: boolean;
}

// rename to generic for phone number and email addresses
const InputMaxRetries = ({ name, editable }: InputMaxRetriesProps) => {
  return (
    <FormSection name={name} component={Fragment}>
      <Field
        id='num-attempts'
        name='num-attempts'
        component={InputField}
        placeholder='Enter a value'
        disabled={!editable}
      ></Field>
    </FormSection>
  );
};

export default InputMaxRetries;
